import { render, staticRenderFns } from "./serviceSubscript.vue?vue&type=template&id=af62945c&scoped=true"
import script from "./serviceSubscript.vue?vue&type=script&lang=js"
export * from "./serviceSubscript.vue?vue&type=script&lang=js"
import style0 from "./serviceSubscript.vue?vue&type=style&index=0&id=af62945c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af62945c",
  null
  
)

export default component.exports